import { create } from 'zustand';
import { notificationsApi } from '../lib/api';

interface NotificationsState {
  unreadCount: number;
  isLoading: boolean;
  
  // Actions
  fetchUnreadCount: () => Promise<void>;
  decrementUnreadCount: () => void;
  setUnreadCount: (count: number) => void;
  clearUnreadCount: () => void;
}

export const useNotificationsStore = create<NotificationsState>()((set) => ({
  unreadCount: 0,
  isLoading: false,

  fetchUnreadCount: async () => {
    set({ isLoading: true });
    try {
      const response = await notificationsApi.getUnreadCount();
      if (response.data.success) {
        set({ unreadCount: response.data.data?.count || 0 });
      }
    } catch (error) {
      console.error('Failed to fetch unread count:', error);
    } finally {
      set({ isLoading: false });
    }
  },

  decrementUnreadCount: () => {
    set((state) => ({ unreadCount: Math.max(0, state.unreadCount - 1) }));
  },

  setUnreadCount: (count: number) => {
    set({ unreadCount: count });
  },

  clearUnreadCount: () => {
    set({ unreadCount: 0 });
  },
}));

